import axios from "axios";
import { getDeviceId } from "@/lib/device";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Attach the anonymous device ID to every request (both the shared instance
// below and raw axios calls across pages).
axios.defaults.headers.common["X-Device-Id"] = getDeviceId();

export const api = axios.create({ baseURL: API });
api.defaults.headers.common["X-Device-Id"] = getDeviceId();

export const getBreeds = (params = {}) =>
  api.get("/breeds", { params }).then((r) => r.data);
export const getBreed = (id) => api.get(`/breeds/${id}`).then((r) => r.data);

export const getTrainingTips = (id) => api.get(`/breeds/${id}/training-tips`).then((r) => r.data);

export const getHealthNutrition = (id) => api.get(`/breeds/${id}/health-nutrition`).then((r) => r.data);
export const submitQuiz = (answers) =>
  api.post("/quiz/match", answers).then((r) => r.data);
export const getCost = (payload) =>
  api.post("/cost/estimate", payload).then((r) => r.data);
export const getAdoption = (params = {}) =>
  api.get("/adoption", { params }).then((r) => r.data);
export const getShelters = (postcode) =>
  api.get("/shelters", { params: postcode ? { postcode } : {} }).then((r) => r.data);
export const getTrainers = (postcode) =>
  api.get("/trainers", { params: postcode ? { postcode } : {} }).then((r) => r.data);
export const getGuides = () => api.get("/guides").then((r) => r.data);
export const getGuide = (slug) =>
  api.get(`/guides/${slug}`).then((r) => r.data);
